import {connect} from "react-redux";
import OfferModal from "../../../components/Modals/OfferModal/OfferModal";
import {setShowOfferModal} from "../../../actions/modal";

export const MapStateToProps = (state) => ({
    showOfferModal: state.modal.showOfferModal,
    dataUser: state.user.dataUser
});

export const MapDispatchToProps = (dispatch) => ({
    setShowOfferModal: (bool) => {
        dispatch(setShowOfferModal(bool));
    },
});

export default connect(MapStateToProps, MapDispatchToProps)(OfferModal);